import { ReactElement, ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface ListMembershipRowProps {
  id: string
  name: string
  to?: string
  detail?: string
  stage: ReactNode
  actions?: ReactNode
}

/** One list a contact is on: the list name and its stage control, with an optional detail line. */
export function ListMembershipRow({ id, name, to, detail, stage, actions }: ListMembershipRowProps): ReactElement {
  const nameClassName = `min-w-0 flex-1 truncate text-label-sm text-strong`

  return (
    <div
      data-testid={`list-row-${id}`}
      className="flex w-full flex-col gap-0.5 rounded-lg border border-default bg-surface-subtle px-3 py-2 shadow-elevation-1"
    >
      <div className="flex w-full items-center gap-2">
        {to ? (
          <Link to={to} title={name} className={`${nameClassName} hover:underline`}>
            {name}
          </Link>
        ) : (
          <span title={name} className={nameClassName}>
            {name}
          </span>
        )}
        {stage}
        {actions && <div className="flex shrink-0 items-center gap-1">{actions}</div>}
      </div>
      {detail && <span className="truncate text-body-xs text-subtle">{detail}</span>}
    </div>
  )
}
